const BreadcrumbManager = {
  storageKey: 'shopify_breadcrumb_history',
  
  init() {
    this.trackHistory();
    this.renderCrumbs();
    this.bindMegaMenu();
  },

  trackHistory() {
    let history = JSON.parse(sessionStorage.getItem(this.storageKey)) || [{t: 'Home', u: '/'}];
    const currentPage = {
      t: (document.querySelector('h1')?.innerText || document.title.split('–')[0].split('|')[0]).trim(),
      u: window.location.pathname,
      type: this.getPageType()
    };

    // If we land on Home, reset history
    if (currentPage.u === '/') {
      history = [{t: 'Home', u: '/'}];
    } 
    else if (currentPage.type === 'collection') {
      const index = history.findIndex(item => item.u === currentPage.u);
      
      if (index !== -1) {
        // User went back to a previous collection in the path
        history = history.slice(0, index + 1);
      } else {
        // Append new collection to path
        history.push(currentPage);
      }
    }
    else if (currentPage.type === 'product') {
      // Ensure product is always the last item and doesn't duplicate
      history = history.filter(item => item.type !== 'product');
      history.push(currentPage);
    }

    sessionStorage.setItem(this.storageKey, JSON.stringify(history));
  },

  getPageType() {
    if (window.location.pathname === '/') return 'home';
    if (window.location.pathname.includes('/collections/')) return 'collection';
    if (window.location.pathname.includes('/products/')) return 'product';
    return 'other';
  },

  bindMegaMenu() {
    // Identify your Megamenu links. Add a class 'js-mega-menu-link' to them in Liquid.
    document.querySelectorAll('.mega-menu a, .js-mega-menu-link').forEach(link => {
      link.addEventListener('click', () => {
        // When clicking a major category, reset the path to Home > New Category
        sessionStorage.removeItem(this.storageKey);
      });
    });
  },

  renderCrumbs() {
    const history = JSON.parse(sessionStorage.getItem(this.storageKey));
    console.log("got here");
    if (!history || history.length <= 1) return; // Liquid handled it fine
console.log("here bread");
    const container = document.querySelector('.breadcrumb__list');
    
    if (!container) return;
    console.log("breadcrumb rendered");
    // Build the new HTML based on actual session history
    let newHtml = '';
    history.forEach((item, index) => {
      const isLast = index === history.length - 1;
      newHtml += `
        <li class="breadcrumb__item">
          <a href="${item.u}" ${isLast ? 'aria-current="page"' : ''}>${item.t}</a>
        </li>
      `;
      if (!isLast) {
        newHtml += `<span class="breadcrumb__divider" aria-hidden="true">/</span>`;
      }
    });

    container.innerHTML = newHtml;
  }
};

document.addEventListener('DOMContentLoaded', () => BreadcrumbManager.init());